import { PageBreadcrumb } from '@/components';
import WIPImage from '@/assets/images/egg.png';

import { Interweave } from 'interweave';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

interface Props {
	title?: string;
	description?: string;
}

export default function WorkingInProgress({ title, description }: Props) {
	return (
		<>
			<PageBreadcrumb title="Estamos innovando" subName="NotImplemented" />
			<div className="account-pages pt-2 pt-sm-5 pb-4 pb-sm-5">
				<Container>
					<Row className="justify-content-center">
						<Col lg={8}>
							<div className="text-center">
								<img
									src={WIPImage}
									alt="Working in Progress"
									className="img-fluid "
									width={250}
								/>
							</div>
							<div className="text-center">
								<h1 className="mt-4 fw-lighter font-roboto">CREATING VALUE</h1>

								{title && (
									<p className="text-muted mt-3">
										Estamos innovando
										<br />
										<span className="fw-bold">{title}</span>
									</p>
								)}
								<p className="text-muted mt-3">
									{description ? (
										<Interweave content={description} />
									) : (
										`¡Parece que has llegado a un pequeño bache en el camino! No te
									preocupes, estamos trabajando arduamente en esta función para
									que pronto puedas disfrutar de una experiencia increíble.
									¡Gracias por tu paciencia!`
									)}
								</p>
								<Link className="btn btn-info mt-3" to="/dashboard/climatization">
									<i className="mdi mdi-reply"></i> Volver a tu dashboard
								</Link>
							</div>
						</Col>
					</Row>
				</Container>
			</div>
		</>
	);
}
